import type { MsAdlActivityLabels } from "../en-GB/msAdlCopy";

export const msAdlCopyIt: MsAdlActivityLabels = {
    Walking: "Camminare",
    Cooking: "Cucinare",
    Driving: "Guidare",
    Shopping: "Spesa",
    Work: "Lavoro",
    Sport: "Sport",
    Housework: "Lavori domestici",
    Socialising: "Vita sociale",
};
